import {permissionTnpType} from "./type"
export const loadPermissionsTnpActions = (params) => ({
    type: permissionTnpType.LOAD_PERMISSIONS_TNP_DATA_START,
    params
})

export const setPermissionsTnpActionsSuccess = (params) => ({
    type: permissionTnpType.SET_PERMISSIONS_TNP_SUCCESS,
    params
})

export const setPermissionsTnpActionsError = (params) => ({
    type: permissionTnpType.SET_PERMISSIONS_TNP_ERROR,
    params
})